// import * as AWS from "aws-sdk";
import * as AWS from 'aws-sdk';

const BUCKET_NAME = 'artearte-bucket'

AWS.config.region = 'eu-west-2'; // Region
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'eu-west-2:8aa76e65-cfa6-4640-a2c4-4be8d3421264',
});


const s3 = new AWS.S3({
    region: 'eu-west-2',
    apiVersion: '2006-03-01',
    params: {Bucket: BUCKET_NAME}
});


export {
    s3,
    BUCKET_NAME
}

